// extracted by mini-css-extract-plugin
module.exports = {"orangeButton":"NavBarButton_orangeButton__1motl","BlueButton":"NavBarButton_BlueButton__1jnS5"};